const celerioSliders = [
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-Front-Left-Side.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-Front-Left-Side.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-grille.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-grille.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-front-fog-lamp.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-front-fog-lamp.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-headlight.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-headlight.webp',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-ignition-start-stop-button.webp',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-ignition-start-stop-button.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-instrument-cluster.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-instrument-cluster.webp',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-gear-shifter.webp',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-gear-shifter.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-interior-image.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/Maruti-Suzuki-Celerio-interior-image.webp',
  },
];

const celerioColors = [
  {
    id: 1,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/colors/Maruti-Suzuki-Clerio-GLISTENING_GREY.webp',
  },
  {
    id: 2,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/colors/Maruti-Suzuki-Clerio-SILKY_SILVER.webp',
  },
  {
    id: 3,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/colors/Maruti-Suzuki-Clerio-white.webp',
  },
  {
    id: 4,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/colors/Maruti-Suzuki-Clerio-Speedy-Blue.webp',
  },
  {
    id: 5,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/celerio/colors/Maruti-Suzuki-Clerio-Fire-Red.webp',
  },
  {
    id: 6,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/celerio/celerio-black.webp',
  },
];

const celerioVariants = [
  {
    id: 1,
    title: 'lxi',
    transmission: 'manual',
    mileage: '25.24',
    price: '₹ 5,64,000 Lakh',
  },
  {
    id: 2,
    title: 'vxi',
    transmission: 'manual',
    mileage: '25.24',
    price: '₹ 5,99,500 Lakh',
  },
  {
    id: 3,
    title: 'zxi',
    transmission: 'manual',
    mileage: '25.24',
    price: '₹ 6,39,000 Lakh',
  },
  {
    id: 4,
    title: 'ZXI+',
    transmission: 'manual',
    mileage: '24.97',
    price: '₹ 6,87,000 Lakh',
  },
  {
    id: 5,
    title: 'VXI AGS',
    transmission: 'automatic',
    mileage: '26.68',
    price: '₹ 6,49,500 Lakh',
  },
  {
    id: 6,
    title: 'ZXI AGS',
    transmission: 'automatic',
    mileage: '26.00 ',
    price: '₹ 6,89,000 Lakh',
  },
  {
    id: 7,
    title: 'ZXI+ AGS',
    transmission: 'automatic',
    mileage: '26.00',
    price: '₹ 7,37,000 Lakh',
  },
  {
    id: 8,
    title: 'VXI CNG',
    transmission: 'MANUAL',
    mileage: '34.43',
     price: '₹ 6,89,500 Lakh',
  },
  {
    id: 9,
    title: '',
    transmission: '',
    mileage: '',
    price: '',
  },
];

const celerioMileage = [
  {
    id: 1,
    title: 'petrol',
    transmission: 'LXi MT',
    mileage: '25.24 KM/L',
  },
  {
    id: 2,
    title: 'petrol',
    transmission: 'VXi MT',
    mileage: '25.24 KM/L',
  },
  {
    id: 3,
   title: 'cng',
    transmission: 'VXi CNG MT',
    mileage: '34.43 KM/KG',
  },
  {
    id: 4,
    title: 'petrol',
    transmission: 'VXi AGS',
    mileage: '26.68 KM/L',
  },
  {
    id: 5,
   title: 'petrol',
    transmission: 'ZXi MT',
    mileage: '25.24 KM/L',
  },
  {
    id: 6,
    title: 'petrol',
    transmission: 'ZXi AGS',
    mileage: '26.00 KM/L',
  },
  {
    id: 7,
    title: 'petrol',
    transmission: 'ZXi+ MT',
    mileage: '24.97 KM/L',
  },
  {
    id: 8,
   title: 'petrol',
    transmission: 'ZXi+ AGS',
    mileage: '26.00 KM/L',
  },
];
 const celerioData = {
  name: "Celerio",
  brand: "Maruti Suzuki",
  priceRange: "₹ 5.64 - 7.37 Lakh*",
  specs: [
    { label: "Engine", value: "998 cc",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/speedometer.png",  },
    { label: "Mileage", value: "34.43 km/kg*",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/gas-station.png", },
    { label: "Power (KW)", value: "49" ,icon : "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/car.png", },
  ],
  iconUrls: [
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/AGS.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/S-CNG_mimimum+black.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/K-SERIES.webp",
  ],
  brochureLink:
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/brochures/Saboo_RKS_All_New_Celerio.pdf",
  compareLink: "/compare-cars",
  cngLink: "/maruti-celerio-cng-on-road-price-in-hyderabad",
};

export { celerioSliders, celerioColors, celerioVariants, celerioMileage ,celerioData};
